export const getOnboardSteps = (t: (text: string) => string, onBoardStart: boolean) => {
  if (!onBoardStart) return [];

  return [
    {
      disableBeacon: true,
      target: 'redirect-2',
      data: {
        navigateBefore: '/',
        previousItemIndex: 11, //Index of the last item that had a mounted target from /src/pages/ActionItems/helpers/getOnboardSteps.js
      },
    },
    {
      target: '#tourStep-13',
      content: t(
        'Details about the installation point are displayed, including: A summary of the observed issue, Action item urgency, Equipment name, Sensor installation point photos',
      ),
      placement: 'bottom',
    },
    {
      target: '#tourStep-14',
      content: t(
        'Detailed recommendations are provided by the Waites analyst, including recommended next steps.',
      ),
      placement: 'top',
    },
    {
      target: '#tourStep-15',
      content: t(
        'You can respond to an action item with a question or comment for Waites analysts to review and attach files as needed. After doing this, the action item status will change to Waiting.',
      ),
      placement: 'bottom',
    },
    {
      target: '#tourStep-16',
      content: t(
        'You can snooze an action item if needed. For example, the repair requires downtime, and you need to schedule the work at a specific time in the future, or the parts are not available to make the repair.',
      ),
      placement: 'top',
    },
    {
      target: '#tourStep-17',
      content: t(
        'After you have completed your maintenance, press “Close Action Item” to submit a completion report, detailing the work you have completed. The status will change to Verifying.If a Completion Report has already been created, this button will display "Resubmit" or "Edit" instead depending on the status.',
      ),
      placement: 'top',
    },
    {
      target: '#tourStep-18',
      content: t(
        'Waites analysts will then collect data over the coming days to confirm the issue has been properly resolved. If everything looks good, the action item will be archived and will no longer appear in the Action Item list. If any further actions are needed, the completion report will be declined with recommendations on further maintenance steps to conduct.',
      ),
      placement: 'bottom',
    },
    {
      target: 'redirect-3',
      data: {
        navigateAfter: 'sensors',
      },
    },
  ];
};
